import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { string, bool, func } from 'prop-types';
import { translate } from 'react-i18next';

import {
  CheckIcon,
  HexagonExclamationIcon,
  CircleQuestionIcon,
  AlertBanner,
} from '@snapask/common-components';

import errorTheme from '@snapask/common-components/styles/alertBannerTheme/error.scss';
import successTheme from '@snapask/common-components/styles/alertBannerTheme/success.scss';
import warningTheme from '@snapask/common-components/styles/alertBannerTheme/warning.scss';
import systemInfoTheme from '@snapask/common-components/styles/alertBannerTheme/systemInfo.scss';

import {
  ALERT_SUCCESS_THEME,
  ALERT_ERROR_THEME,
  ALERT_WARNING_THEME,
  ALERT_SYSTEMINFO_THEME,
} from '@blueberry/constants/alertBannerThemes';

import {
  hideAlertBanner,
  getAlertMessage,
  getAlertTheme,
  getIsBannerAlive,
  getAlertBannerStatus,
} from '@blueberry/redux/alertBanner';

const mapStateToProps = state => ({
  alertMessage: getAlertMessage(state),
  alertThemeType: getAlertTheme(state),
  isBannerAlive: getIsBannerAlive(state),
  showAlertBanner: getAlertBannerStatus(state),
});

function AlertBannerHandler({
  hideAlertBanner,
  alertMessage,
  alertThemeType,
  t,
  isBannerAlive,
  showAlertBanner,
}) {
  const getAlertTheme = alertType => {
    switch (alertType) {
      case ALERT_SUCCESS_THEME:
        return successTheme;
      case ALERT_WARNING_THEME:
        return warningTheme;
      case ALERT_ERROR_THEME:
        return errorTheme;
      case ALERT_SYSTEMINFO_THEME:
        return systemInfoTheme;
      default:
        return {};
    }
  };

  const getAlertIcon = alertType => {
    switch (alertType) {
      case ALERT_SUCCESS_THEME:
        return <CheckIcon width={18} />;
      case ALERT_WARNING_THEME:
        return <HexagonExclamationIcon width={18} />;
      case ALERT_ERROR_THEME:
        return <HexagonExclamationIcon width={18} />;
      case ALERT_SYSTEMINFO_THEME:
        return <CircleQuestionIcon width={18} />;
      default:
        return undefined;
    }
  };

  return (
    <div>
      {showAlertBanner && (
        <AlertBanner
          // a tricky way to handle both 'true string' and 'crowdin id'
          alertText={t(alertMessage)}
          theme={getAlertTheme(alertThemeType)}
          icon={getAlertIcon(alertThemeType)}
          onClose={hideAlertBanner}
          keepAlive={isBannerAlive}
        />
      )}
    </div>
  );
}

AlertBannerHandler.propTypes = {
  alertMessage: string.isRequired,
  alertThemeType: string.isRequired,
  hideAlertBanner: func.isRequired,
  isBannerAlive: bool.isRequired,
  showAlertBanner: bool.isRequired,
  t: func.isRequired,
};

export default compose(
  translate(['common']),
  connect(mapStateToProps, {
    hideAlertBanner,
  })
)(AlertBannerHandler);



// WEBPACK FOOTER //
// ./app/containers/AlertBannerHandler/AlertBannerHandler.jsx